function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES = {
  BEGIN: 'RETRIEVE_CHANGE_OFFER_ELEGIBILITY_RULES.BEGIN',
  SUCCESS: 'RETRIEVE_CHANGE_OFFER_ELEGIBILITY_RULES.SUCCESS',
  FAILURE: 'RETRIEVE_CHANGE_OFFER_ELEGIBILITY_RULES.FAILURE'
};
export var RETRIEVE_SUBSCRIBER_OFFERINGS = {
  BEGIN: 'RETRIEVE_SUBSCRIBER_OFFERINGS_BEGIN',
  SUCCESS: 'RETRIEVE_SUBSCRIBER_OFFERINGS_SUCCESS',
  FAILURE: 'RETRIEVE_SUBSCRIBER_OFFERINGS_FAILURE'
};
var RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES_CONSTANTS = [RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.BEGIN, RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.SUCCESS, RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.FAILURE];
export var retrieveChangeOfferEligibilityRulesPromise = function retrieveChangeOfferEligibilityRulesPromise(dispatch, customerId, offeringIds) {
  return ThunkHelper(dispatch, RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES_CONSTANTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveChangeOfferEligibilityRules',
    data: {
      OfferingInstanceIds: offeringIds
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveChangeOfferEligibilityRules = function retrieveChangeOfferEligibilityRules(customerId, offeringIds) {
  return function (dispatch) {
    return retrieveChangeOfferEligibilityRulesPromise(dispatch, customerId, offeringIds);
  };
};